import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_caret_right",
  "use": "icon-icon_caret_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_caret_right\"><defs><style></style></defs><path d=\"M321.331 875.52l409.6-346.726a21.914 21.914 0 0 0 0-33.383l-409.6-346.726a21.914 21.914 0 0 0-36.045 16.793v693.248a21.914 21.914 0 0 0 36.045 16.794z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol